/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CourseregistrationDocumentApprovalOcrSnapshot200,
  PostApiV1CourseregistrationDocumentApprovalOcrSnapshot400,
  PostApiV1CourseregistrationDocumentApprovalOcrSnapshot401,
  PostApiV1CourseregistrationDocumentApprovalOcrSnapshot500,
  PostApiV1CourseregistrationDocumentApprovalOcrSnapshotMutationRequest,
  PostApiV1CourseregistrationDocumentApprovalOcrSnapshotMutationResponse,
} from "../../types/courseRegistrationDocumentApprovalController/PostApiV1CourseregistrationDocumentApprovalOcrSnapshot.ts";
import { documentOcrSnapshotRequestViewModelSchema } from "../documentOcrSnapshotRequestViewModelSchema.ts";
import { documentOcrSnapshotResultViewModelSchema } from "../documentOcrSnapshotResultViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1CourseregistrationDocumentApprovalOcrSnapshot200Schema =
  z.array(
    z.lazy(() => documentOcrSnapshotResultViewModelSchema),
  ) as unknown as ToZod<PostApiV1CourseregistrationDocumentApprovalOcrSnapshot200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CourseregistrationDocumentApprovalOcrSnapshot400Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationDocumentApprovalOcrSnapshot400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CourseregistrationDocumentApprovalOcrSnapshot401Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationDocumentApprovalOcrSnapshot401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CourseregistrationDocumentApprovalOcrSnapshot500Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationDocumentApprovalOcrSnapshot500>;

export const postApiV1CourseregistrationDocumentApprovalOcrSnapshotMutationRequestSchema =
  z.lazy(
    () => documentOcrSnapshotRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1CourseregistrationDocumentApprovalOcrSnapshotMutationRequest>;

export const postApiV1CourseregistrationDocumentApprovalOcrSnapshotMutationResponseSchema =
  z.lazy(
    () => postApiV1CourseregistrationDocumentApprovalOcrSnapshot200Schema,
  ) as unknown as ToZod<PostApiV1CourseregistrationDocumentApprovalOcrSnapshotMutationResponse>;
